import {isStaging} from "../utils/isStaging";

export const proxyUrlRemote = 'https://proxy.kidiup.com/v1/proxy';
export const proxyUrlLocal = 'http://127.0.0.1:6060/v1/proxy';

export const proxyUrl = true ? proxyUrlRemote : proxyUrlLocal;
export const productionGoogleID = "";
export const stagingGoogleID = "";
export const googleID = isStaging() ? stagingGoogleID : productionGoogleID;
